/* Sticky nav on scroll up ----------------------------------------------- */
// This whole bit could probably be cleaned up
// Reference:
// https://daily-dev-tips.com/posts/show-and-hide-a-header-based-on-scroll-direction/
const mobileHeader = document.querySelector(".site-nav-mobile");
const desktopHeader = document.querySelector(".site-nav-desktop");

let lastScroll = 0;

const throttle = (func, time = 100) => {
  let lastTime = 0;
  return () => {
    const now = new Date();
    if (now - lastTime >= time) {
      func();
      time = now;
    }
  };
};

const validateHeader = () => {
	const windowY = window.scrollY;
	const windowH = window.innerHeight;
	const scrollPointH = 100;

  if (windowY > scrollPointH) {
    // We passed scroll point, set a toggable class
    mobileHeader.classList.add("is-fixed");
    desktopHeader.classList.add("is-fixed");

    // Determine if we're ready to animate
    if (windowY > scrollPointH + 100) {
      mobileHeader.classList.add("can-animate");
      desktopHeader.classList.add("can-animate");

      if (windowY < lastScroll) {
        // Determine if we scrolling up
        mobileHeader.classList.add("scroll-up");
        desktopHeader.classList.add("scroll-up");
      } else {
			mobileHeader.classList.remove("scroll-up");
			desktopHeader.classList.remove("scroll-up");
      }
    } else {
      mobileHeader.classList.remove("scroll-up");
      desktopHeader.classList.remove("scroll-up");
    }
  } else {
	mobileHeader.classList.remove("is-fixed", "can-animate");
	desktopHeader.classList.remove("is-fixed", "can-animate");
  }
  lastScroll = windowY;
};

window.addEventListener("scroll", throttle(validateHeader, 100));

// Make sure that the top padding on main is only for mobile...
const mobileNavMQ = window.matchMedia('(max-width: 1099px)');
const contentMain = document.querySelector('#main');
const mobileHeroImage = document.querySelector('.t-formPage .hero__image > img');
const mobileHeroImageOffset = 54;

// Get header height
const mobileHeaderHeight = mobileHeader.offsetHeight;
const desktopHeaderHeight = desktopHeader.offsetHeight;
const blockScroll = document.querySelectorAll(".block-scroll");

function handleMobileNavChange(e) {
	// Check if the media query is true
	if (e.matches) {
		// mobileHeader.removeProperty("display");
		mobileHeader.style.display = 'block';
		// Get the main#main element and give it padding
		// equal to the mobile header height, which may or may
		// not include the campaign banner
		// contentMain.style.paddingTop = mobileHeaderHeight  + 24 + 'px';
		contentMain.style.paddingTop = mobileHeaderHeight  + 'px';
		const totalMobileHeroImageOffset = mobileHeroImageOffset + mobileHeaderHeight;
		if(typeof(mobileHeroImage) != 'undefined' && mobileHeroImage != null){
			mobileHeroImage.style.top = totalMobileHeroImageOffset + 'px';
		 }
		// console.log('mobile header height is:' + mobileHeaderHeight);
	} else {
		mobileHeader.style.display = 'none';
		// Remove the top padding on #main since we're on desktop
		// contentMain.style.paddingTop = null;
		contentMain.style.removeProperty("padding-top");
		if(typeof(mobileHeroImage) != 'undefined' && mobileHeroImage != null){
			mobileHeroImage.style.removeProperty("top");
		}
		// console.log('desktop header height is: ' + desktopHeaderHeight);

		// For each .block-scroll div/section, give a scroll-margin-top equal
		// to the height of the desktop header, which may or may not
		// include the campaign banner
		for(let i=0; i < blockScroll.length; i++){
			blockScroll[i].style.scrollMarginTop = desktopHeaderHeight + 'px';
		}
	}
}

// Register event listener
mobileNavMQ.addEventListener("change", handleMobileNavChange);

// Initial check
handleMobileNavChange(mobileNavMQ);
